module.exports = __webpack_public_path__ + "stylesheets/global_dcd057b669bae4ce8b961490666ec4f5.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 118